export const PACKAGE_NAME = 'jiraRecurringIssueAction';
export const TEAM_NAME = 'a4t-pandora';
export const HAS_SEEN_RECURRING_WORK_PULSE_KEY = 'has_seen_recurring_work_pulse';

export const DISABLED = 'DISABLED' as const;
export const ENABLED = 'ENABLED' as const;
export const MISSING_PERMS = 'MISSING_PERMS' as const;
